export function useField() {
    const focusRingClasses =
        'focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface';

    const focusWithinRingClasses =
        'focus-within:outline-hidden focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-surface';

    const normalThemeClasses = `transition-ease rounded-md form-input block w-full text-sm shadow-xs text-primary border-divider bg-surface sm:text-sm placeholder-muted focus:border-brand ${focusRingClasses} focus:ring-brand`;

    const errorThemeClasses = `transition-ease rounded-md pr-10 bg-surface placeholder-red-light text-danger border-danger focus:border-danger ${focusRingClasses} focus:ring-danger`;

    const disabledThemeClasses =
        'rounded-md disabled:border-secondary--inverse bg-surface disabled:cursor-not-allowed disabled:text-muted';

    return {
        focusWithinRingClasses: focusWithinRingClasses,
        focusRingClasses: focusRingClasses,
        normalThemeFieldClasses: normalThemeClasses,
        errorThemeFieldClasses: errorThemeClasses,
        disabledThemeFieldClasses: disabledThemeClasses,
    };
}
